import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";

// Hangar
import { Icon, MaxModal, Button, Input, Link } from "@maxmilhas/hangar-components-atomic/public";

// Components
import BoundDetails from "./BoundDetails";

// Helpers
import { capitalizeFirst } from "../../helpers/string";
import { translateDuration, timeToString, dateToMediumString } from "../../helpers/dateTime";

// Style
import { styleStretch } from "./style";

const MAX_SIZE_BOUNDS = 2;
const MAX_LIMIT_HIDDEN = 2;

const Stretch = ({ bounds, filters, dictionaries, offerId, direction, onChangeBounds }) => {
	const [selected, setSelected] = useState();
	const [flightDetails, setFlightDetails] = useState(null);
	const [openDetails, setOpenDetails] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [listBounds, setListBounds] = useState(
		bounds.length > MAX_SIZE_BOUNDS + MAX_LIMIT_HIDDEN ? bounds.slice(0, MAX_SIZE_BOUNDS) : bounds
	);
	const qtyShow = expanded ? bounds.length : MAX_SIZE_BOUNDS;
	const qtyHide = bounds.length - qtyShow;
	const handleSelecBound = bound => {
		setSelected(`${offerId}-${bound.id}`);
		if (typeof onChangeBounds === "function") {
			onChangeBounds(bound);
		}
	};
	const handleExpandList = () => {
		if (expanded) {
			setListBounds(bounds.slice(0, MAX_SIZE_BOUNDS));
		} else {
			setListBounds(bounds);
		}
		setExpanded(!expanded);
	};
	useEffect(() => {
		if (
			listBounds &&
			listBounds.length > 0 &&
			(!selected || listBounds.find(bound => `${offerId}-${bound.id}` === selected) === undefined)
		) {
			handleSelecBound(listBounds[0]);
		}
	}, [listBounds]);
	const handleOpenDetails = (evt, bound) => {
		setFlightDetails(bound);
		setOpenDetails(true);
		evt.preventDefault();
	};
	const listPeriods = () => {
		const periods = filters.reduce((prev, filter) => {
			if (!prev.includes(filter.departurePeriod)) {
				prev.push(filter.departurePeriod);
			}
			if (!prev.includes(filter.arrivalPeriod)) {
				prev.push(filter.arrivalPeriod);
			}
			return prev;
		}, []);
		return periods
			.map(period => {
				let str = "";
				if (period === "00:00-05:59") {
					str = "Madrugada";
				} else if (period === "06:00-11:59") {
					str = "Manhã";
				} else if (period === "12:00-17:59") {
					str = "Tarde";
				} else {
					str = "Noite";
				}
				return str;
			})
			.join(" • ");
	};
	return (
		<>
			{direction === "inbound" && <hr />}
			<div
				className={css`
					${styleStretch}
				`}
			>
				<div className="header-stretch">
					<div>
						<Icon size="small" name={`icon-max-travel-plane-${direction}`} />
						<strong>{direction === "outbound" ? "Ida" : "Volta"}</strong> -{" "}
						{bounds.length > 0 && dateToMediumString(bounds[0].departure.dateTime)}
					</div>
					<div className='header-periods'>{listPeriods()}</div>
				</div>
				<div className="bounds">
					{listBounds.map(bound => (
						<div key={bound.id} className={selected === `${offerId}-${bound.id}` ? "selected" : ""}>
							<div className="radio">
								<Input
									type="radio"
									id={`${offerId}-${bound.id}`}
									name={`${offerId}-${direction}`}
									checked={selected === `${offerId}-${bound.id}`}
									onChange={() => handleSelecBound(bound)}
									label=" "
								/>
							</div>
							<div className="airline">
								<div className="flag">
									<img
										src={`https://hangar-components-search.s3.amazonaws.com/img/airlines/${bound.carrier}.png`}
										alt={`Marca da cia aérea ${capitalizeFirst(
											dictionaries.airline[bound.carrier] || bound.carrier
										)}`}
										title={capitalizeFirst(dictionaries.airline[bound.carrier] || bound.carrier)}
										width="24"
										height="24"
										onError={e => (e.target.style.display = "none")}
										onLoad={e => (e.target.style.opacity = 1)}
									/>
								</div>
								<span>{capitalizeFirst(dictionaries.airline[bound.carrier] || bound.carrier)}</span>
							</div>
							<div className="info">
								<div className="departure">
									{bound.departure.locationCode}{" "}
									<strong>{timeToString(bound.departure.dateTime)}</strong>
								</div>
								<div className="duration">
									<span className="time">{translateDuration(bound.duration)}</span>
									<span className="stops">
										{bound.totalStops === 0
											? "Direto"
											: `${bound.totalStops} ${bound.totalStops > 1 ? "paradas" : "parada"}`}
									</span>
								</div>
								<div className="arrival">
									{bound.arrival.locationCode}{" "}
									<strong>
										{timeToString(bound.arrival.dateTime)}{" "}
										{bound.daysDifference > 0 && <span>+{bound.daysDifference}</span>}
									</strong>
								</div>
							</div>
							<div className="details">
								<Link href="#" onClick={evt => handleOpenDetails(evt, bound)}>
									Detalhes
								</Link>
								<MaxModal
									open={openDetails}
									onClose={() => setOpenDetails(false)}
									focusTrapped={false}
								>
									{flightDetails && (
										<>
											<BoundDetails bound={flightDetails} dictionaries={dictionaries} />
											<Button onClick={() => setOpenDetails(false)} outline>
												Voltar
											</Button>
										</>
									)}
								</MaxModal>
							</div>
						</div>
					))}
				</div>
				{bounds.length > MAX_SIZE_BOUNDS + MAX_LIMIT_HIDDEN && (
					<Button onClick={handleExpandList} outline>
						Mostrar {expanded ? "menos" : "mais"} voos {!expanded && `(${qtyHide})`}
					</Button>
				)}
			</div>
		</>
	);
};

Stretch.propTypes = {
	bounds: PropTypes.array,
	filters: PropTypes.array,
	dictionaries: PropTypes.object,
	offerId: PropTypes.string,
	direction: PropTypes.oneOf(["outbound", "inbound"]),
	onChangeBounds: PropTypes.func
};

Stretch.defaultProps = {
	bounds: [],
	filters: [],
	dictionaries: null,
	offerId: null,
	direction: "OW",
	onChangeBounds: null
};

export default Stretch;
